export default "__VITE_ASSET__3ee509fb__"